import Vue from 'vue';
import App from './App.vue';
import './styles/global.scss'; // 导入全局样式
Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
